import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../../../../Constant';
import axios from 'axios';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { toast, ToastContainer } from 'react-toastify';
import messages from '../../../../../assets/Messages.json';
import 'react-toastify/dist/ReactToastify.css';

function NetProfitTally() {
  const navigate = useNavigate();
  
  // State for header data
  const [headerData, setHeaderData] = useState({
    despatchSlNo: '',
    permanentSlNo: '',
    companyName: '',
    surveyYear: ''
  });

  // State for API data
  const [apiData, setApiData] = useState({
    expenses: { items: [], total: 0 },
    receipts: { items: [], total: 0 },
    net_profit: 0
  });
  const [loading, setLoading] = useState(false);

  // Fetch header data from localStorage when component mounts
  useEffect(() => {
    const fetchHeaderData = () => {
      try {
        // Get form data from localStorage (stored by balanceSheet page)
        const balanceSheetData = localStorage.getItem('balanceSheetFormData');

        if (balanceSheetData) {
          const parsedData = JSON.parse(balanceSheetData);

          setHeaderData({
            despatchSlNo: parsedData.dslNo || '',
            permanentSlNo: parsedData.pslNo || '',
            companyName: parsedData.nameUnit || '',
            surveyYear: parsedData.year || ''
          });
        } else {
          // If no data in localStorage, set defaults
          console.log('No balanceSheet data found in localStorage');
          setHeaderData({
            despatchSlNo: 'DSL No. not set',
            permanentSlNo: 'PSL No. not set',
            companyName: 'Company name not set',
            surveyYear: 'Survey Year not set'
          });
        }
      } catch (error) {
        console.error('Error fetching data from localStorage:', error);
        setHeaderData({
          despatchSlNo: 'Error loading data',
          permanentSlNo: 'Error loading data',
          companyName: 'Error loading data',
          surveyYear: 'Error loading data'
        });
      }
    };

    fetchHeaderData();
  }, []);

  // Ref to prevent multiple API calls
  const apiCallMadeRef = useRef(false);

  // API call to fetch data
  useEffect(() => {
    const fetchApiData = async () => {
      // Prevent multiple API calls
      if (apiCallMadeRef.current) {
        console.log('API call already made, skipping...');
        return;
      }

      if (!headerData.despatchSlNo || !headerData.surveyYear) {
        console.log('Missing DSL No or Survey Year');
        return;
      }

      // Check if we already called API for this exact DSL and Year
      const callKey = `${headerData.despatchSlNo}-${headerData.surveyYear}`;
      if (apiCallMadeRef.current === callKey) {
        console.log('API already called for this DSL and Year combination');
        return;
      }

      apiCallMadeRef.current = callKey;

      try {
        setLoading(true);
        showLoading(true);
        
        const jwtToken = localStorage.getItem('jwt');
        const token = localStorage.getItem('token');
        
        // Use JWT token if available, otherwise use regular token
        const authToken = jwtToken || token;
        
        if (!authToken) {
          toast.error('Authentication token not found. Please login again.', messages.COLOR_RED);
          setLoading(false);
          showLoading(false);
          apiCallMadeRef.current = false;
          return;
        }
        
        // Create separate payload
        const payload = {
          dsl_no: headerData.despatchSlNo,
          survey_year: headerData.surveyYear
        };
        
        console.log('API Payload:', payload);
        console.log('JWT Token:', jwtToken);
        console.log('Regular Token:', token);
        console.log('Using Auth Token:', authToken);
        
        const response = await axios.post(
          `${API_URL}api/blockd/net-profit-tally`,
          payload,
          {
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Access-Control-Allow-Origin': '*'
            }
          }
        );

        if (response.data.status) {
          setApiData(response.data.data || {
            expenses: { items: [], total: 0 },
            receipts: { items: [], total: 0 },
            net_profit: 0
          });
          console.log('API Response:', response.data);
        } else {
          toast.warning('No data found for this DSL No. and Survey Year.', messages.COLOR_RED);
        }
      } catch (error) {
        console.error('Error fetching API data:', error);
        
        if (error.response?.status === 401) {
          toast.error('Session expired. Please login again.', messages.COLOR_RED);
        } else if (error.response?.status === 404) {
          toast.warning('No data found for this DSL No. and Survey Year.', messages.COLOR_RED);
        } else {
          toast.error(`Error loading data: ${error.message}`, messages.COLOR_RED);
        }
      } finally {
        setLoading(false);
        showLoading(false);
      }
    };

    // Only call if we have required data and haven't called yet
    if (headerData.despatchSlNo && headerData.surveyYear && !apiCallMadeRef.current) {
      fetchApiData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array - only run once on mount
  return (
    <>
      <GlobalLoading />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
      <style>
        {`
          .net-profit-header {
            background-color: #e3f2fd;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
          }
          .page-title {
            color: #ff9800;
            font-size: 24px;
            font-weight: bold;
            margin: 0;
          }
          .dispatch-number {
            color: #333333;
            font-size: 16px;
            font-weight: 600;
            margin: 0;
          }
          .company-info {
            background-color: #fff;
            border: 1px solid #e0e0e0;
            border-radius: 6px;
            padding: 15px;
            margin-bottom: 20px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          .company-field {
            border: 1px solid #e0e0e0;
            background-color: #f8f9fa;
            padding: 8px 12px;
            font-size: 14px;
            border-radius: 4px;
            margin-bottom: 10px;
          }
          .section-title {
            background-color: #f8f9fa;
            color: #333333;
            font-weight: bold;
            font-size: 16px;
            padding: 10px 15px;
            border-radius: 4px 4px 0 0;
            margin: 0;
            border: 1px solid #e0e0e0;
            border-bottom: none;
            text-align: center;
          }
          .table th {
            background-color: #f8f9fa;
            border: 1px solid #e0e0e0;
            color: #333333;
            font-weight: 600;
            font-size: 12px;
            text-align: center;
            vertical-align: middle;
            padding: 8px 6px;
          }
          .table td {
            border: 1px solid #e0e0e0;
            padding: 6px 8px;
            font-size: 11px;
            text-align: center;
            vertical-align: middle;
          }
          .table tbody tr:nth-child(even) {
            background-color: #f8f9fa;
          }
          .table tbody tr:nth-child(odd) {
            background-color: #ffffff;
          }
          .amount-cell {
            text-align: center;
            font-weight: 600;
          }
          .total-row {
            background-color: #e3f2fd !important;
            font-weight: bold;
          }
          .net-profit-section {
            text-align: center;
            margin-top: 30px;
            padding: 20px;
            background-color: #f8f9fa;
            border-radius: 8px;
            border: 2px solid #e0e0e0;
          }
          .net-profit-value {
            border: 2px solid #4caf50;
            background-color: #4caf50;
            color: white;
            padding: 25px 50px;
            font-size: 24px;
            font-weight: bold;
            border-radius: 8px;
            display: inline-block;
            min-width: 300px;
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
            text-align: center;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          .table-responsive {
            overflow-x: auto;
            max-width: 100%;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="net-profit-header">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="page-title">Net Profit Tally</h1>
            </div>
            <div className="col-md-6 text-end">
              {/* <p className="dispatch-number">DSL No: {headerData.despatchSlNo || 'Not Available'}</p> */}
              <p className="dispatch-number">Survey Year: {headerData.surveyYear || 'Not Available'}</p>
            </div>
          </div>
        </div>

        {/* Company Information Section */}
        <div className="card mx-3 mb-3">
          <div className="card-body">
            <div className="company-info">
              <div className="row">
                <div className="col-md-4 mb-2">
                  <label className="form-label mb-1" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                    Permanent Sl. No.:
                  </label>
                  <div className="company-field">{headerData.permanentSlNo || 'Not Available'}</div>
                </div>
                <div className="col-md-4 mb-2">
                  <label className="form-label mb-1" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                    Despatch Sl. No.:
                  </label>
                  <div className="company-field">{headerData.despatchSlNo || 'Not Available'}</div>
                </div>
                <div className="col-md-4 mb-2">
                  <label className="form-label mb-1" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                    Name of Company.:
                  </label>
                  <div className="company-field">{headerData.companyName || 'Not Available'}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="card mx-3 mb-3">
          <div className="card-body">
            <div className="row">
              {/* Expenses Section */}
              <div className="col-md-6">
                <div className="table-responsive">
                  <h3 className="section-title">Expenses</h3>
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th style={{ width: '15%' }}>Sl no.</th>
                        <th style={{ width: '65%' }}>Item</th>
                        <th style={{ width: '20%' }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="3" className="text-center">Loading...</td>
                        </tr>
                      ) : (
                        <>
                          {apiData.expenses.items.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.item_name}</td>
                              <td className="amount-cell">{item.amount.toLocaleString()}</td>
                            </tr>
                          ))}
                          <tr className="total-row">
                            <td colSpan="2">Total Expenses</td>
                            <td className="amount-cell">{apiData.expenses.total.toLocaleString()}</td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Receipt Section */}
              <div className="col-md-6">
                <div className="table-responsive">
                  <h3 className="section-title">Receipt</h3>
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th style={{ width: '15%' }}>Sl no.</th>
                        <th style={{ width: '65%' }}>Item</th>
                        <th style={{ width: '20%' }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="3" className="text-center">Loading...</td>
                        </tr>
                      ) : (
                        <>
                          {apiData.receipts.items.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.item_name}</td>
                              <td className="amount-cell">{item.amount.toLocaleString()}</td>
                            </tr>
                          ))}
                          <tr className="total-row">
                            <td colSpan="2">Total Income</td>
                            <td className="amount-cell">{apiData.receipts.total.toLocaleString()}</td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Net Profit Section */}
            <div className="net-profit-section">
              <div className="net-profit-value">
                NET PROFIT = {loading ? 'Loading...' : apiData.net_profit.toLocaleString()}
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">

            <button
              type="button"
              className="btn btn_orange mx-1"
              // onClick={() => navigate('/validation')}
              onClick={() => navigate('/validation')}
            >
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => navigate('/check-pl-account-sorted')}
            >
              <i className="fa fa-angle-left me-1"></i>
              Previous
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => navigate('/error-list')}
            >
              Next
              <i className="fa fa-angle-right ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default NetProfitTally; 